import core, { GQL } from '@gin-betting/core';
import { favoritePages, ACTIVE_MARKET_STATUSES } from 'app-constants';

const { isOneOfPages } = core.utils;

export default function getMarketStatusesByLocation() {
    if (isOneOfPages(favoritePages.result)) {
        return [GQL.MarketStatus.RESULTED];
    }

    return ACTIVE_MARKET_STATUSES;
}
